import { createStore, compose } from "redux";
import appRootReducer from "./rootReducer";

const AUTH_STORAGE_KEY = "TrackLeads_AUTH_STATE";

const loadAuthState = () => {
  try {
    const data = localStorage.getItem(AUTH_STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  } catch (err) {
    console.error("Failed to load auth state:", err);
    return null;
  }
};

const saveAuthState = (auth) => {
  try {
    const payload = JSON.stringify(auth);
    localStorage.setItem(AUTH_STORAGE_KEY, payload);
  } catch (err) {
    console.error("Failed to save auth state:", err);
  }
};

const clearAuthStorage = () => {
  try {
    localStorage.removeItem(AUTH_STORAGE_KEY);
  } catch (err) {
    console.error("Failed to clear auth storage:", err);
  }
};

const initialAuthState = {
  loginName: null,
  userId: null,
  orgdbName: "",
  serverip: "",
  dbusername: "",
  dbpassword: "",
dbid:"",
orgname:"",
  remember: false,
};

const persistedAuth = loadAuthState();
const authInitialState = persistedAuth || initialAuthState;

export const setAuth = (payload) => ({ type: "auth/setAuth", payload });
export const clearAuth = () => ({ type: "auth/clearAuth" });
export const setOrgDbName = (orgdbName) => ({
  type: "auth/setOrgDbName",
  payload: orgdbName,
});

const preloadedState = {
  auth: authInitialState,
};

// ✅ DevTools enhancer — ye missing tha
const composeEnhancers =
  (typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

const store = createStore(
  appRootReducer,
  preloadedState,
  composeEnhancers()
);

store.subscribe(() => {
  const state = store.getState();
  const { auth } = state;
  if (auth && auth.loginName) {
    saveAuthState(auth);
  } else {
    clearAuthStorage();
  }
});

export default store;